
export const sidemenuData: any[] = [
  { label: 'Dashboard', url: 'dashboard', items: [] },
  { label: 'Course', url: 'courses', items: [] },
  { label: 'Exam', url: 'exam', items: [] },
  { label: 'Flashcard', url: null, items: [] },
  { label: 'Roles', url: null, items: [] },
{ label: 'Associates', url: 'associates', items: [] },
  { label: 'Payments', url: null, items: [] },
  { label: 'Certification & Badges', url: 'master-data', items: [] },
  { label: 'Referral System', url: null, items: [] },
  { label: 'Social Media', url: null, items: [] },
  { label: 'Messaging', url: null, items: [] },
  { label: 'Website Setup', url: null, items: [] },
  { label: 'Menus', url: 'main-menus', items: [] },
  { label: 'Clients', url: 'clients', items: [] },
  { label: 'Role Menus', url: 'users-menu', items: [] },
  { label: 'Privacy Policy', url: 'privacy-policy', items: [] }
];

export const dashboard_transactions: any[] = [
  {
    date: "13 Dec, 2024",
    studentName: "Prajakta Bhavsar",
    mobile: "99999 99999",
    courseName: "1000 Vocab - Video",
    courseType: "Video",
    amount: 1000
  },
  {
    date: "13 Dec, 2024",
    studentName: "Raj Mehta",
    mobile: "98888 12345",
    courseName: "English Booster Pack",
    courseType: "Video",
    amount: 1200
  },
  {
    date: "13 Dec, 2024",
    studentName: "Sneha Raut",
    mobile: "98765 43210",
    courseName: "Grammar Mastery",
    courseType: "Video",
    amount: 900
  },
  {
    date: "13 Dec, 2024",
    studentName: "Vikram Desai",
    mobile: "91234 56789",
    courseName: "Advanced Comprehension",
    courseType: "Video",
    amount: 1100
  },
  {
    date: "13 Dec, 2024",
    studentName: "Ritika Singh",
    mobile: "99887 77665",
    courseName: "1000 Vocab - Video",
    courseType: "Video",
    amount: 1000
  },
  {
    date: "13 Dec, 2024",
    studentName: "Amitabh Joshi",
    mobile: "98712 34567",
    courseName: "Speaking Fluency",
    courseType: "Video",
    amount: 950
  },
  {
    date: "13 Dec, 2024",
    studentName: "Tanvi Patil",
    mobile: "99001 22334",
    courseName: "Comprehensive IELTS Prep",
    courseType: "Video",
    amount: 1500
  },
  {
    date: "13 Dec, 2024",
    studentName: "Karan Kapoor",
    mobile: "99911 11122",
    courseName: "1000 Vocab - Video",
    courseType: "Video",
    amount: 1000
  },
  {
    date: "13 Dec, 2024",
    studentName: "Neha Kulkarni",
    mobile: "98888 66777",
    courseName: "English Grammar Crash Course",
    courseType: "Video",
    amount: 800
  },
  {
    date: "13 Dec, 2024",
    studentName: "Yash Agarwal",
    mobile: "98765 78901",
    courseName: "Business English Essentials",
    courseType: "Video",
    amount: 1300
  }
];

export const courses: any[] = [
  {
    "course_type": "video",
    "course_name": "Introduction to Python Programming",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "draft",
    "id": 301
  },
  {
    "course_type": "exam",
    "course_name": "Advanced Data Structures",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/17484899/pexels-photo-17484899/free-photo-of-an-artist-s-illustration-of-artificial-intelligence-ai-this-image-represents-the-boundaries-set-in-place-to-secure-safe-accountable-biotechnology-it-was-created-by-khyati-trehan-as-pa.png",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "pending",
    "id": 302
  },
  {
    "course_type": "flashcard",
    "course_name": "Machine Learning Basics",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/373543/pexels-photo-373543.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "approved",
    "id": 303
  },
  {
    "course_type": "video",
    "course_name": "Web Development with JavaScript",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/270404/pexels-photo-270404.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "draft",
    "id": 304
  },
  {
    "course_type": "exam",
    "course_name": "Cybersecurity Fundamentals",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/374074/pexels-photo-374074.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "pending",
    "id": 305
  },
  {
    "course_type": "flashcard",
    "course_name": "Digital Marketing Strategies",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "approved",
    "id": 306
  },
  {
    "course_type": "video",
    "course_name": "Graphic Design Essentials",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/1983035/pexels-photo-1983035.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "draft",
    "id": 307
  },
  {
    "course_type": "exam",
    "course_name": "Project Management Professional (PMP) Prep",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "pending",
    "id": 308
  },
  {
    "course_type": "flashcard",
    "course_name": "Artificial Intelligence Overview",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/1181317/pexels-photo-1181317.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "approved",
    "id": 309
  },
  {
    "course_type": "video",
    "course_name": "Cloud Computing Concepts",
    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "thumbnail": "https://images.pexels.com/photos/1181271/pexels-photo-1181271.jpeg",
    "usefull_for_hint": "1,1,1,1",
    "is_active": 1,
    "status": "draft",
    "id": 310
  }
]




export const courseStructure = {
  "status": "success",
  "code": 200,
  "message": "Course structure retrieved successfully",
  "data": [
    {
      "id": 14,
      "parent_id": "0",
      "course_id": 1,
      "structure_name": "Hello Durgesh",
      "description": "Hello Durgesh! This is testing",
      "child": [],
      "structure_maps": []
    },
    {
      "id": 15,
      "parent_id": "0",
      "course_id": 1,
      "structure_name": "Physics",
      "description": "Hello Durgesh! This is testing",
      "child": [
        {
          "id": 16,
          "parent_id": "15",
          "course_id": 1,
          "structure_name": "Physics Topic 1",
          "description": "Hello Durgesh! This is testing",
          "structure_maps": [],
          "grandChild": [
            {
              "id": 17,
              "parent_id": "16",
              "course_id": 1,
              "structure_name": "Physics Sub Topic 1",
              "description": "Hello Durgesh! This is testing",
              "structure_maps": [
                {
                  "id": 8,
                  "structure_id": 17,
                  "action_id": 16,
                  "action_type": "video",
                  "video": {
                    "id": 16,
                    "video_title": "Testing video 17",
                    "video_link": "http://localhost:8000/api/v1/master/video/create",
                    "video_lock": true,
                    "is_reel_link": true,
                    "video_duration": "300",
                    "theory": "sdhsdhsddsfsf sf sdf sdf dsf ds fds f dsf dsfd fds",
                    "theory_lock": true,
                    "thumbnail": null,
                    "no_of_views": "0",
                    "views_lock": true,
                    "price": "100",
                    "price_lock": true
                  },
                  "certificate": null
                }
              ],
              "grandChild": []
            },
            {
              "id": 18,
              "parent_id": "16",
              "course_id": 1,
              "structure_name": "Physics Sub Topic 2",
              "description": "Hello Durgesh! This is testing",
              "structure_maps": [
                {
                  "id": 9,
                  "structure_id": 18,
                  "action_id": 17,
                  "action_type": "video",
                  "video": {
                    "id": 17,
                    "video_title": "Testing video18",
                    "video_link": "http://localhost:8000/api/v1/master/video/create",
                    "video_lock": true,
                    "is_reel_link": true,
                    "video_duration": "300",
                    "theory": "sdhsdhsddsfsf sf sdf sdf dsf ds fds f dsf dsfd fds",
                    "theory_lock": true,
                    "thumbnail": null,
                    "no_of_views": "0",
                    "views_lock": true,
                    "price": "100",
                    "price_lock": true
                  },
                  "certificate": null
                }
              ],
              "grandChild": []
            },
            {
              "id": 19,
              "parent_id": "16",
              "course_id": 1,
              "structure_name": "Physics Sub Topic 3",
              "description": "Hello Durgesh! This is testing",
              "structure_maps": [
                {
                  "id": 10,
                  "structure_id": 19,
                  "action_id": 18,
                  "action_type": "video",
                  "video": {
                    "id": 18,
                    "video_title": "Testing video19",
                    "video_link": "http://localhost:8000/api/v1/master/video/create",
                    "video_lock": true,
                    "is_reel_link": true,
                    "video_duration": "300",
                    "theory": "sdhsdhsddsfsf sf sdf sdf dsf ds fds f dsf dsfd fds",
                    "theory_lock": true,
                    "thumbnail": null,
                    "no_of_views": "0",
                    "views_lock": true,
                    "price": "100",
                    "price_lock": true
                  },
                  "certificate": null
                },
                {
                  "id": 11,
                  "structure_id": 19,
                  "action_id": 19,
                  "action_type": "video",
                  "video": {
                    "id": 19,
                    "video_title": "Testing video19",
                    "video_link": "http://localhost:8000/api/v1/master/video/create",
                    "video_lock": true,
                    "is_reel_link": true,
                    "video_duration": "300",
                    "theory": "sdhsdhsddsfsf sf sdf sdf dsf ds fds f dsf dsfd fds",
                    "theory_lock": true,
                    "thumbnail": null,
                    "no_of_views": "0",
                    "views_lock": true,
                    "price": "100",
                    "price_lock": true
                  },
                  "certificate": null
                }
              ],
              "grandChild": []
            }
          ]
        },
        {
          "id": 20,
          "parent_id": "15",
          "course_id": 1,
          "structure_name": "Physics Topic 2",
          "description": "Hello Durgesh! This is testing",
          "structure_maps": [],
          "grandChild": [
            {
              "id": 21,
              "parent_id": "20",
              "course_id": 1,
              "structure_name": "Physics SUb Topic 20-1",
              "description": "Hello Durgesh! This is testing",
              "structure_maps": [
                {
                  "id": 7,
                  "structure_id": 21,
                  "action_id": 15,
                  "action_type": "video",
                  "video": {
                    "id": 15,
                    "video_title": "Testing video21",
                    "video_link": "http://localhost:8000/api/v1/master/video/create",
                    "video_lock": true,
                    "is_reel_link": true,
                    "video_duration": "300",
                    "theory": "sdhsdhsddsfsf sf sdf sdf dsf ds fds f dsf dsfd fds",
                    "theory_lock": true,
                    "thumbnail": null,
                    "no_of_views": "0",
                    "views_lock": true,
                    "price": "100",
                    "price_lock": true
                  },
                  "certificate": null
                }
              ],
              "grandChild": []
            }
          ]
        }
      ],
      "structure_maps": []
    }
  ]
}